module.exports = __webpack_public_path__ + "img/20.64ca5158.png";